import Vue from 'vue'
Vue.config.devtools = true
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'

import VueAxios from 'vue-axios'
import { axiosFRExt, axiosExt, axiosInt, axiosSec } from './drivers/axios'

Vue.use(VueAxios, {
  secured: axiosSec,
  internal: axiosInt,
  frExternal: axiosFRExt,
  external: axiosExt
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
